const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTMgMzQyIj4KPHJlY3QgeT0iODUuMzMzIiBmaWxsPSIjMDA4NzUxIiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjM0MiIvPgo8cmVjdCB4PSIxOTYuNjY2IiB5PSI4NS4zMzMiIGZpbGw9IiNmY2QxMTYiIHdpZHRoPSIzMTYuMzM0IiBoZWlnaHQ9IjE3MSIvPgo8cmVjdCB4PSIxOTYuNjY2IiB5PSIyNTYiIGZpbGw9IiNlODExMmQiIHdpZHRoPSIzMTYuMzM0IiBoZWlnaHQ9IjE3MSIvPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=BJ-74b43ce9.mjs.map
